import { render, staticRenderFns } from "./pedersenVerify.vue?vue&type=template&id=15c5c116&scoped=true&"
import script from "./pedersenVerify.vue?vue&type=script&lang=js&"
export * from "./pedersenVerify.vue?vue&type=script&lang=js&"
import style0 from "./pedersenVerify.vue?vue&type=style&index=0&id=15c5c116&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c5c116",
  null
  
)

export default component.exports